export const API_URL = `${import.meta.env.PUBLIC_API_URL}/api`;
export const SENTRY_DSN_AUTH = import.meta.env.PUBLIC_SENTRY_DSN_AUTH;
